<template>
  <ipo3-page>
    <template slot="title">首頁新聞</template>
    <template slot="tools">
      <el-select v-model="form.type" @change="onChangeType" style="margin-right: 14px;">
        <el-option v-for="item in select_types" :key="item.name" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="form.language" @change="onChangeLanguage" style="margin-right: 14px;">
        <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">{{$t('btns.add')}}</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.create_at|formDate}}
               </template>
            </el-table-column>
            
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >編輯</el-button>
                <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="首页新闻" name="1">
          首页新闻
        </el-tab-pane>
        <el-tab-pane label="推荐" name="2">认证信息</el-tab-pane>
      </el-tabs>-->
    </template>
  </ipo3-page>
</template>
<script>
const types = ["滾動圖", "固定圖","編輯推薦"];
export default {
  name: "home-news",
  data() {
    return {
      activeName: "1",
      select_types: [{id: 9, name: '全部'}, {id: 0, name: '滾動圖'}, {id: 1, name: '固定圖'}, {id: 2, name: '編輯推薦'}],
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      form:{
        type: 9,
        language: 'tw'
      },
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: this.$table.home_menus,
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },

  created() {
    this.getData();
  },

  watch: {
    $route: {
      async handler(newVal) {
        let params = this.$route.query;
        if (params.language != undefined && params.language != null && params.language != '')
          this.form.language = params.language;
        this.currentPage = params.page||1;
        this.paginate = params.size||10;
        this.getData(this.currentPage, this.paginate, params);
      },
      immediate: true,
    }
  },

  methods: {
    getData(page=1,size=10,params={}) {
      var self = this;
      this.$http.get("/admin/HomeNews", {page:page,size:size,...params}).then(res => {
        let {data,total} = res.data;
        self.pagecount = total;
        data.forEach(item => {
          item.name = types[item.type];
        });
        self.tableData = res.data.data;
      });
    },

    onCreate() {
      this.$router.push({ path: "/dashboard/home-news-edit", query: {language:this.language}});
    },

    onHandle(index, id) {
      this.$router.push({ path: `/dashboard/home-news-edit/${id}` });
    },

    handleSizeChange(size)
    {
      let params = Object.assign({},this.form);
      this.paginate = size;
      params.page = 1;
      params.size = this.paginate;
      this.$router.push({path:'/dashboard/home-news',query:params})
    },

    handleCurrentChange(val)
    {
      let params = Object.assign({},this.form);
      params.page = val;
      params.size = this.paginate;
      this.$router.push({path:'/dashboard/home-news',query:params});
    },

    onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/HomeNews/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            let params = Object.assign({},this.form);
            self.getData(this.currentPage, this.paginate, params);
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },

    onChangeLanguage(value) {
      let params = Object.assign({},this.form);
      this.currentPage = 1;
      this.getData(this.currentPage, this.paginate, params);
    },

    onChangeType(value) {
      let params = Object.assign({},this.form);
      this.currentPage = 1;
      this.getData(this.currentPage, this.paginate, params);
    },
  }
};
</script>